import { getBrkPropertiesData } from '../../../../services/utilities/apis/brk';
import { INTERFACE_PANEL_TRIGGERS, TAB_STATUS } from '../../../../constants';
import { isPointInsideOrgPolygonOrBBox } from '../../../../services/map/boundingBox';
import { getBagVboFeatureInfoFromFilters } from '../../../../services/map/feature/selection';

const store = {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async getBrkProperties({ dispatch, getters, commit }, { name, data, title }) {
            //Clear possible results for this title and open new tab with status Loading
            dispatch('initTabObjectSearch', { title });

            try {
                let brkData = data._embedded.kadastraalOnroerendeZaken;
                const propertyData = getBrkPropertiesData(data, brkData);

                // Make sure the applicatie zooms to the found features.
                let featureResults = [];
                let pointInsideBbox = true;
                let zoomToFeatures = true;
                if (brkData !== undefined) {
                    featureResults = await dispatch('getFeaturesBrk', { data: brkData[0] });
                    if (featureResults?.length > 0) {
                        pointInsideBbox = isPointInsideOrgPolygonOrBBox(getters.getUserData, featureResults[0].getGeometry());
                        zoomToFeatures = pointInsideBbox;
                    }
                }

                commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: propertyData,
                    count: brkData?.length ?? 0,
                    exportable: true,
                    download: true,
                    printable: true,
                    naturalPersons: true,
                    features: featureResults,
                    zoomToFeatures,
                    pointInsideBbox,
                    status: TAB_STATUS.READY
                });
                dispatch('trackUserEvent', { name: 'getBrkProperties', stage: name });
            } catch (err) {
                commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: {
                        'items': [],
                        'fields': []
                    },
                    maxResultsExceeded: false,
                    count: 0,
                    status: TAB_STATUS.ERROR,
                    message: err.message
                });
            }
        },

        async getFeaturesBrk(store, { data }) {
            if (data.adressen) {
                const items = data?.adressen?.map(item => {
                    return {
                        postcode: item?.postcode,
                        huisnummer: item?.huisnummer,
                        huisletter: item?.huisletter === undefined ? '' : item?.huisletter,
                        toevoeging: item?.toevoeging === undefined ? '' : item?.toevoeging
                    };
                });

                return getBagVboFeatureInfoFromFilters(
                    store,
                    items
                );
            } else {
                return null;
            }
        },

        GetBrkDetailedInformation(store, { data }) {
            const isAppartment = data.type === 'appartementsrecht';
            store.dispatch('togglePanel', {
                panelName: INTERFACE_PANEL_TRIGGERS.BRK,
                visible: true,
                data: {
                    parcelIdentificationLocalID: data.identificatie,
                    isAppartment: isAppartment,
                    title: isAppartment ? data.adresregel1 : data.kadastraleAanduiding
                }
            });
        }
    }
};

export default store;
